import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { EventActivity, Lead, ModelID } from '@/types';
import { get } from '@/utils/api';
import { useQuery } from '@tanstack/react-query';

const featurePath = '/v4/tools/sales/schedule-gaps';

type QueryFnType = typeof fetchScheduleGaps;

type UseScheduleGapsOptions = {
  location: ModelID;
  search: {
    start_date: string;
    end_date: string;
    gap_tolerance_minutes?: number;
  };
  config?: QueryConfig<QueryFnType>;
};

type ScheduleGapsKeyType = EventActivity & {
  potential_gap_fillers: Lead[] | null;
};

export const fetchScheduleGaps = (location: ModelID, search: UseScheduleGapsOptions['search']) =>
  get<ScheduleGapsKeyType[]>(`${featurePath}?franchise_id=${location}`, search);

export const useScheduleGaps = ({ location, search, config = {} }: UseScheduleGapsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [{ scope: 'scheduleGaps', location, search }],
    queryFn: () => fetchScheduleGaps(location, search),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
